<template>
  <div>
    <!-- 邮件发送 -->
    <el-dialog :title="$t('message.mailSending')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="888px" center>
      <!-- 邮件标题 -->
      <div class="content" style="margin-bottom:30px">
        <div class="label">
          {{ $t("message.mailTitle") }}：
        </div>
        <div class="val">
          <el-input v-model="datas.title" onfocus="this.select()" :placeholder="$t('message.mailTitle')"></el-input>
        </div>
      </div>
      <!-- 邮件内容 -->
      <div class="content">
        <div class="label">
          {{ $t("message.mailContent") }} ：
        </div>
        <div class="val">
          <el-input v-model="datas.content" type="textarea" :placeholder="$t('message.mailContent')"></el-input>
          <!-- <quill-editor ref="myTextEditor" id="quill-editor" v-model="datas.content" :options="quillOption"
            @change="onEditorChange($event)">
          </quill-editor> -->
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- 保存 -->
        <el-button type="primary" @click="save">
          {{ $t("message.save") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { quillEditor } from "vue-quill-editor";
import quillConfig from "@/utlis/quill-config";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
export default {
  components: {
    quillEditor,
  },
  props: {
    id: { type: Number },
  },
  data() {
    return {
      quillOption: quillConfig,
      datas: {
        title: '',
        content: '',
      },
      dialogVisible: false
    };
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible) {
        this.datas = {}
      }
    },
  },
  methods: {
    // 保存
    save() {
      // 邮件标题不能为空
      if (this.datas.title == "")
        return this.$message.error(
          this.$t("message.theEmailSubjectCannotBeBlank")
        );
      if (this.datas.content == "")
        return this.$message.error(
          this.$t("message.theEmailContentCannotBeEmpty")
        );
      this.datas.user_id = this.id
      this.$api.JapaneseOffice.sendEmail(this.datas).then((res) => {
        this.$message.success(res.msg);
        this.dialogVisible = false
      });
    },
    onEditorChange(e) {
      // console.log(e);
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;
  display: flex;

  .label {
    width: 100px;
    line-height: 40px;
  }

  .val {
    flex: 3;
  }
}

/deep/.el-textarea__inner {
  width: 100% !important;
  min-height: 200px !important
}
</style>